package com.vizio.redwolf.pay.model

import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable
import kotlin.js.JsExport

@Serializable
@JsExport
data class Plan(
    @SerialName("partnerId") val partnerId: String,
    @SerialName("appId") val appId: String?,
    @SerialName("planCode") val planCode: String,
    @SerialName("appName") val appName: String? = null,
    @SerialName("name") val name: String? = null,
    @SerialName("description") val description: String,
    @SerialName("price") val price: String,
    @SerialName("billingInterval") val billingInterval: String,
    @SerialName("trialLength") val trialLength: String,
    @SerialName("imageUrl") val imageUrl: String? = null,
    @SerialName("isActive") val isActive: Boolean? = null,
    @SerialName("isBundle") val isBundle: Boolean? = null,
    @SerialName("addOns") val addOns: List<SubscriptionPlanAddOns>? = null,
    @SerialName("bundleApps") val bundleApps: List<BundleApps>? = null
)

@Serializable
@JsExport
data class BundleApps(
    @SerialName("appName") val appName: String? = null,
    @SerialName("imageUrl") val imageUrl: String? = null
)

@Serializable
@JsExport
data class SubscriptionPlanAddOns(
    @SerialName("code") val code: String,
    @SerialName("name") val name: String,
    @SerialName("description") val description: String,
    @SerialName("price") val price: String,
    @SerialName("imageUrl") val imageUrl: String,
    @SerialName("hyperlinkUrl") val hyperlinkUrl: String? = null,
    @SerialName("freeTrialDays") val freeTrialDays: Int? = null
)

@Serializable
@JsExport
data class UpgradePlan(
    val planCode: String,
    val appName: String,
    val name: String,
    val price: String,
    val billingInterval: String,
    val billingDate: String,
    val imageUrl: String,
    val selected: Boolean
)

@Serializable
data class AccountPlan(
    @SerialName("action") val action: String,
    @SerialName("buttonText") val actionDescription: String,
    @SerialName("pricingText") val priceDescription: String,
    @SerialName("additionalText") val description: String,
    @SerialName("subscriptionId") val subscriptionId: String?,
    @SerialName("plan") val plan: Plan,
)